// extracted by mini-css-extract-plugin
export default {"cls1":"HashtagSelector-cls1__e0ca516d927807e6fee6","cls2":"HashtagSelector-cls2__c6c578dc24b5549ed0a1 HashtagSelector-cls1__e0ca516d927807e6fee6"};